"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var constants_1 = require("../../core/constants");
var GqlSeasons = require("../../core/gql/queries/seasons");
var GqlArchiveSeasonMutation = require("../../core/gql/mutations/archive-season");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var season_1 = require("../../models/season");
/**
 * SeasonCard displays a card with season information, including actions that modify that season.
 * @param Props
 *  - @see interface Props above
 */
var SeasonCard = function (_a) {
    var season = _a.season, program = _a.program, selectSeasonIdCallback = _a.selectSeasonIdCallback;
    var showSeason = function (type, id) {
        selectSeasonIdCallback(type, id);
    };
    var archiveSeason = react_apollo_1.useMutation(GqlArchiveSeasonMutation.MUTATION, {
        refetchQueries: [{ query: GqlSeasons.QUERY, variables: { programId: season.programId } }],
    })[0];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    // TODO: Is there a way to do this without the store at this context?
    // Like a cache lookup against the season ID? Can we guarantee it'll be there?
    var programName = program.name;
    var seasonName = season.name;
    var archiveFn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ARCHIVE_SUCCESS, e_1, ARCHIVE_FAILURE;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, archiveSeason({
                            variables: {
                                id: season.id,
                            },
                        })];
                case 1:
                    _a.sent();
                    ARCHIVE_SUCCESS = programName + " " + seasonName + " has been archived.";
                    setFeedbackMessage({
                        variables: {
                            message: ARCHIVE_SUCCESS,
                            isError: false,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    ARCHIVE_FAILURE = "Oops!  We couldn't archive " + programName + " " + seasonName + ". Please try again.";
                    setFeedbackMessage({
                        variables: {
                            message: ARCHIVE_FAILURE,
                            isError: true,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var actions = [{ text: "Edit", callback: function () { return showSeason(season.type, season.id); } }];
    if (!season.isArchived) {
        actions = __spreadArray(__spreadArray([], actions), [
            {
                text: "Archive",
                callback: archiveFn,
                requiresConfirmation: true,
                confirmationText: "Archiving will hide the teams in this season from the mobile apps for all members. Are you sure you want to do this?",
            },
        ]);
    }
    return (React.createElement(teamsnap_ui_1.Panel, { mods: "season-card", key: "season-card-" + season.id },
        React.createElement("div", { className: "u-padMd u-xs-padSidesLg u-flex u-flexAlignItemsCenter u-flexJustifyBetween" },
            React.createElement("div", { className: "Grid" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement("div", { className: "u-spaceBottomSm u-fontSizeXl" },
                        season.tsDivisionId && (React.createElement("a", { href: constants_1.TEAMSNAP_URL + "/team/set_division/" + season.tsDivisionId }, season.name)),
                        !season.tsDivisionId && season.name),
                    React.createElement("p", { className: "u-colorGrey" },
                        season.isArchived ? "Archived" : "Active",
                        season.type == season_1.ActivitySeasonType.ClubSeason ? "" : React.createElement("span", { className: "u-spaceLeftSm" }, "(Legacy Season)"))),
                React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight u-flex u-flexCol u-flexJustifyBetween" },
                    React.createElement("div", { className: "button-list" },
                        React.createElement(teamsnap_ui_1.PopupAction, { direction: ["down", "right"], text: "...", actions: actions, popupStyle: { width: "150px" } })))))));
};
exports.default = SeasonCard;
//# sourceMappingURL=season-card.js.map